import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../views/Home";
import Authenticate from "../views/Authenticate";
import BaseItemIndex from "../views/BaseItem";
import BaseShowItem from "../views/BaseItem/show";
import BaseCreateItem from "../views/BaseItem/create";
import BaseUpdateItem from "../views/BaseItem/update";
import { NavbarLayout } from "./NavbarLayout";
import { ErrorPage, ModelErrorPage } from "../views/ErrorPages";
import BaseSingleItem from "../views/BaseSingleItem";
import UpdateSingleItem from "../views/BaseSingleItem/update";
import Logout from "../views/Logout";
import { useAtomValue } from "jotai";
import { generalDataAtom, loginStatusAtom, userAtom } from "../atoms";
import Settings from "../views/Settings";
import ResetPassword from "../views/ResetPassword";
import RequestReset from "../views/RequestReset";
import UserIndex from "../views/Users";
import CreateUser from "../views/Users/create";
import ShowUser from "../views/Users/show";
import UpdateUser from "../views/Users/update";
import { MFAAuth } from "../views/MFAAuth";
import RequestMFAReset from "../views/RequestMFAReset";
import ResetMFA from "../views/ResetMFA";
import { Analytics } from "../views/Analytics";

const PrivatePages = (): JSX.Element => {
  const loginStatus = useAtomValue(loginStatusAtom);
  return loginStatus ? <NavbarLayout /> : <Logout />;
};

const AppRoutes = () => {
  const user = useAtomValue(userAtom);
  const generalData = useAtomValue(generalDataAtom);
  const showUserMgmt =
    user?.user_role === "admin" && generalData.enable_user_management;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth" element={<Authenticate />} />
        <Route path="/login" element={<Authenticate />} />
        <Route path="/mfa_auth" element={<MFAAuth />} />
        <Route path="/logout" element={<Logout />} />
        {/* <Route path="/another_hidden_signup_page" element={<Settings />} /> */}
        <Route path="/request_reset" element={<RequestReset />} />
        <Route path="/request_mfa_reset" element={<RequestMFAReset />} />
        <Route path="/reset_password" element={<ResetPassword />} />
        <Route path="/reset_mfa" element={<ResetMFA />} />
        {/* <Route path="/analytics" element={<Analytics />} /> */}
        <Route path="*" element={<ErrorPage />} />
        <Route element={<PrivatePages />}>
          <Route index element={<Home />} />
          <Route path="/m/:model" element={<BaseItemIndex />} />
          <Route path="/m/:model/create" element={<BaseCreateItem />} />
          <Route path="/m/:model/edit/:id" element={<BaseUpdateItem />} />
          <Route path="/m/:model/show/:id" element={<BaseShowItem />} />
          <Route path="/si/:item" element={<BaseSingleItem />} />
          <Route path="/si/:item/edit" element={<UpdateSingleItem />} />
          <Route path="/m/error" element={<ModelErrorPage />} />
          <Route
            path="/m/users/"
            element={showUserMgmt ? <UserIndex /> : <ModelErrorPage />}
          />
          <Route
            path="/m/users/create"
            element={showUserMgmt ? <CreateUser /> : <ModelErrorPage />}
          />
          <Route
            path="/m/users/show/:id"
            element={showUserMgmt ? <ShowUser /> : <ModelErrorPage />}
          />
          <Route
            path="/m/users/edit/:id"
            element={showUserMgmt ? <UpdateUser /> : <ModelErrorPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
